import { z } from 'zod';

export const tourInsuranceSchema = z
  .object({
    required: z.boolean(),
    insuranceIds: z.array(z.string()),
  })
  .refine((data) => !(data.required && data.insuranceIds.length === 0), {
    message: 'Aby wymagać ubezpieczenia, wybierz przynajmniej jedno',
    path: ['insuranceIds'],
  });

export type TourInsuranceFormData = z.infer<typeof tourInsuranceSchema>;

export const tourInsuranceDefaultValues: TourInsuranceFormData = {
  required: false,
  insuranceIds: [],
};
